<template>
  <v-dialog
    v-model="showPrompt"
    max-width="320"
  >
    <v-card>
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="text-h6 mb-1">
            {{ this.$ftUser.name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            Enter {{ usePin ? 'Pin' : 'Password' }} to <b>Clock Cut</b>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <v-text-field
              v-if="usePin"
              ref="pinInput"
              v-model="pinValue"
              type="number"
              :loading="clockingOut"
              pattern="[0-9]"
              class="ft-fake-password"
              label="PIN"
              :error-messages="clockOutErrorMessages"
              :autocomplete="false"
            />
            <v-text-field
              v-else
              ref="passwordInput"
              v-model="passwordValue"
              label="Password"
              type="text"
              :loading="clockingOut"
              class="ft-fake-password"
              append-icon="mdi-arrow-right-circle"
              :error-messages="clockOutErrorMessages"
              :autocomplete="false"
              @click:append="enterPassword"
              @keydown.enter="enterPassword"
            />
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-avatar
          size="80"
        >
          <img
            v-if="this.$ftUser.photoUrl"
            :src="this.$ftUser.photoUrl"
          ><v-icon
            v-else
            size="80"
            color="grey darken-1"
          >
            mdi-account-circle
          </v-icon>
        </v-list-item-avatar>
      </v-list-item>

      <v-card-actions v-if="this.$ftUser.usesPin">
        <v-spacer />

        <v-btn
          text
          :loading="clockingOut"
          @click="setUsePin(!usePin)"
        >
          {{ usePin ? 'Use Password' : 'Use Pin' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import navRoute from '../mixins/navRoute'
import errorHandler from '../mixins/errorHandler'

export default {
  name: 'ClockOutPrompt',
  mixins: [navRoute, errorHandler],
  props: {
    loading: Boolean,
    value: Boolean
  },

  data: function () {
    return {
      showPrompt: false,
      usePin: false,
      passwordValue: null,
      pinValue: null,
      clockOutErrorMessages: [],
      clockingOut: false
    }
  },
  computed: {
    screenLocked () {
      return this.$ftAS.screenLocked
    }
  },
  watch: {
    screenLocked (val) {
      this.showPrompt = false
    },
    showPrompt (val) {
      if (val != this.value) {
        this.$emit('input', val)
      }
    },
    value (val) {
      this.valueChanged(val)
    },
    passwordValue (v, old) {
      if (v !== old) {
        this.clockOutErrorMessages = []
      }
    },
    pinValue (v, old) {
      const pinLength = this.$ftAC.pinLength
      if (v !== old) {
        this.clockOutErrorMessages = []
      }
      if (typeof v === 'string' && v.length === pinLength) {
        this.$ftAPI().get(this.clockOutCommand(this.$ftUser.username, v, null, false, true))
      }
      if (typeof v === 'string' && v.length > pinLength) {
        setTimeout(()=>{this.pinValue = this.pinValue.substring(0, pinLength)}, 0)
      }
    }
  },
  mounted () {
    this.valueChanged(this.value)
  },
  methods: {
    valueChanged (val) {
      if (this.showPrompt != val) {
        this.showPrompt = val
      }
      if (val) {
        this.setUsePin(this.$ftUser.usesPin)
      }
    },
    enterPassword () {
      this.$ftAPI().get(this.clockOutCommand(this.$$ftUser.username, null, this.passwordValue, false, true))
    },
    clockOutCommand (username, pin, password, clockIn, clockOut) {
      const terminalJwt = this.$ftAPI().getGlobalAppState().jwt
      return [
        {
          command: 'authenticateApp',
          load: (r) => {
            const record = r[0]
            const nextuser = record.user
            // Don't load JWTs from responses for a minute to block any in flight requests from overriding a recently changed jwt
            this.$ftAPI().setSkipResponseToken(Date.now() + 60000)
            // Update access token
            this.$ftAPI().setAccessToken(record.jwt)
            // Same as existing user?
            const sameUser = this.$ftUser.username === nextuser.username
            // Update currently logged in user
            this.$ftAPI().setUser(nextuser)
            // Close window
            this.$ftAPI().setGlobalAppState({userLock: false})
            // Navigate to home screen if not same user
            this.clockingOut = false
            this.showPrompt = false
            if (this.$ftAS.allowScreenLock) this.$ftAPI().lockUserAndScreen()
            if (!sameUser) setTimeout(()=>{
              this.$router.go('/')
            }, 0)
          },
          loading: (v) => {
            this.clockingOut = v
          },
          error: (r) => {
            this.clockingOut = false
            this.clockOutErrorMessages = [r.error]
            console.error('authenticateApp error', r)
          },
          params: {
            filter_methods: {terminalUser: [this.$ftAPI().appMode(), terminalJwt, username, pin, password, clockIn || false, clockOut || false]}
          }
        }
      ]
    },
    setUsePin (v) {
      this.usePin = v
      this.passwordValue = null
      this.pinValue = null
      this.clockingOut = false
      this.clockOutErrorMessages = []
      setTimeout(() => {
        var ref
        if (this.usePin) {
          ref = this.$refs.pinInput
        } else {
          ref = this.$refs.passwordInput
        }
        if (ref) ref.focus()
      }, 0)
    }
  }

}
</script>
